/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Timeline context
import { useTimeline } from "examples/Timeline/context";

// Custom styles for the TimelineItem
import timelineItem from "examples/Timeline/TimelineItem/styles";
import { IconButton, Tooltip } from "@mui/material";

function TimelineItem({
  color,
  icon,
  title,
  dateTime,
  description,
  lastItem,
  onClick,
  width,
  height,
  fontSize,
}) {
  const isDark = useTimeline();

  return (
    <MDBox
      position="relative"
      sx={(theme) => timelineItem(theme, { lastItem, isDark })}
    >
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgColor={color}
        color="white"
        width={width ? width : "1.3rem"}
        height={height ? height : "1.3rem"}
        borderRadius="50%"
        cursor="pointer"
        position="absolute"
        zIndex={2}
      >
        <Tooltip title={title} disableInteractive>
          <IconButton
            color="white"
            sx={{ fontSize: ({ typography: { size } }) => size.xs }}
            onClick={onClick}
          >
            {typeof icon === "string" ? (
              <Icon fontSize={fontSize ? fontSize : "inherit"}>{icon}</Icon>
            ) : (
              <span>{icon}</span>
            )}
          </IconButton>
        </Tooltip>
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of TimelineItem
TimelineItem.defaultProps = {
  color: "info",
  lastItem: false,
  description: "",
};

// Typechecking props for the TimelineItem
TimelineItem.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  icon: PropTypes.node.isRequired,
};

export default TimelineItem;
